/**
 * Brokerage: everything brokers and builders do on the site — registration and login, the partner workspace
 * (dashboard, listing and project editors, leads, profile), the admin review screens, and the enquiry form buyers
 * send from a broker's listing. Backend: app/modules/brokerage. API: ./API.md.
 */
export {default as RegisterPage} from "./pages/RegisterPage";
export {default as LoginPage} from "./pages/LoginPage";
export {default as DashboardPage} from "./pages/DashboardPage";
export {default as ListingEditorPage} from "./pages/ListingEditorPage";
export {default as ProjectEditorPage} from "./pages/ProjectEditorPage";
export {default as AdminPage} from "./admin/AdminPage";
export {default as EnquiryForm} from "./public/EnquiryForm";

/** Routes that render their own workspace chrome instead of the site header/footer. */
export const isWorkspacePath = (pathname) =>
    /^\/broker\/(dashboard|listings|projects)(\/|$)/.test(pathname) || pathname === "/admin/brokers";
